import { render, staticRenderFns } from "./DisputeCaseTags.vue?vue&type=template&id=24b5867e&scoped=true"
import script from "./DisputeCaseTags.vue?vue&type=script&lang=js"
export * from "./DisputeCaseTags.vue?vue&type=script&lang=js"
import style0 from "./DisputeCaseTags.vue?vue&type=style&index=0&id=24b5867e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b5867e",
  null
  
)

export default component.exports